module.exports = __webpack_public_path__ + "img/avatar7.701c35f9.png";